import { Shield } from 'lucide-react';

import type { RegionOption } from '../../../../shared/regionAccessOptions';

interface UsersRegionFilterControlProps {
  value: string | 'any';
  onChange: (regionId: string | 'any') => void;
  /** When set, the control is a locked indicator instead of an open filter. */
  scopedRegionLabel: string | null;
  /** All regions in the tenant. */
  regionOptions: RegionOption[];
  className: string;
}

/** The region filter on the Users list: a select, or a locked pill for a
 *  Regional Director. */
export default function UsersRegionFilterControl({
  value,
  onChange,
  scopedRegionLabel,
  regionOptions,
  className,
}: UsersRegionFilterControlProps) {
  if (scopedRegionLabel) {
    return (
      <span className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg bg-[#EAF3DE] border border-moss-200 text-[12.5px] font-semibold text-moss-700">
        <Shield size={13} />
        {scopedRegionLabel}
        <span className="text-[10.5px] text-stone-500 dark:text-stone-400 font-medium">
          (your region)
        </span>
      </span>
    );
  }
  return (
    <select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Filter by region"
    >
      <option value="any">Region: All</option>
      {regionOptions.map((r) => (
        <option key={r.id} value={r.id}>
          {r.name}
        </option>
      ))}
    </select>
  );
}
